import { notifications } from 'lib/axios';

export const getNotifications = ({ filter, type, pageNumber }) => {
  console.log(`/admin/${filter}/${type}/${pageNumber}`)
  return notifications.get(`/admin/${filter}/${type}/${pageNumber}`);
};

export const useNotifications = ({ filter, type, pageNumber }) => {
  return {
    queryFn: () => getNotifications({ filter, type, pageNumber }),
  };
};
